/**
 * ResizeObserver Loop Fix
 * 
 * This script prevents "ResizeObserver loop completed with undelivered notifications" errors
 * by implementing proper error handling and performance optimizations.
 * 
 * SAFE MODE: Does not modify existing ResizeObserver, only adds error handling
 */

(function() {
  'use strict';

  // Check if already loaded to prevent double execution
  if (window.__resizeObserverFixLoaded) {
    return;
  }
  window.__resizeObserverFixLoaded = true;

  // Global flag to track if we're already handling ResizeObserver errors
  let isHandlingROError = false;

  /**
   * Enhanced error handler specifically for ResizeObserver loop errors
   */
  function handleResizeObserverError(event) {
    if (isHandlingROError) return;
    
    const message = event.message || (event.error && event.error.message) || '';
    
    if (message.includes('ResizeObserver loop') || 
        message.includes('undelivered notifications')) {
      
      isHandlingROError = true;
      
      // Prevent the error from propagating
      event.preventDefault();
      event.stopPropagation();
      
      // Optional: Log for debugging (only in development)
      if (window.Shopify && window.Shopify.designMode) {
        console.debug('ResizeObserver loop detected and handled gracefully');
      }
      
      // Reset the flag after a short delay
      setTimeout(() => {
        isHandlingROError = false;
      }, 100);
      
      return false;
    }
  }

  // Add error listeners with proper cleanup
  window.addEventListener('error', handleResizeObserverError, true);
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver loop')) {
      event.preventDefault();
      if (window.Shopify && window.Shopify.designMode) {
        console.debug('ResizeObserver promise rejection handled');
      }
    }
  });

  /**
   * Utility function for safely creating ResizeObserver instances
   * This does NOT modify the native ResizeObserver
   */
  window.createSafeResizeObserver = function(callback, options = {}) {
    const {
      debounceDelay = 16, // ~60fps
      errorHandler = null
    } = options;

    let timeoutId = null;
    let isProcessing = false;

    const safeCallback = function(entries, observer) {
      if (isProcessing) return;
      
      const processEntries = () => {
        isProcessing = true;
        try {
          if (typeof callback === 'function') {
            callback(entries, observer);
          }
        } catch (error) {
          if (errorHandler && typeof errorHandler === 'function') {
            errorHandler(error);
          } else if (!error.message || !error.message.includes('ResizeObserver loop')) {
            // Only log non-ResizeObserver errors
            console.error('ResizeObserver callback error:', error);
          }
        } finally {
          isProcessing = false;
        }
      };

      if (debounceDelay > 0) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(processEntries, debounceDelay);
      } else {
        requestAnimationFrame(processEntries);
      }
    };

    return new ResizeObserver(safeCallback);
  };

  // Log that the fix has been applied (only in development)
  if (window.Shopify && window.Shopify.designMode) {
    console.debug('ResizeObserver loop fix applied successfully');
  }

})();
